import { render, staticRenderFns } from "./OrderCreationAndEditing.vue?vue&type=template&id=1175b44f&"
import script from "./OrderCreationAndEditing.vue?vue&type=script&lang=js&"
export * from "./OrderCreationAndEditing.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreationAndEditing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports